"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
function TableauNlpRefinementuiWidgetTableCalcWidgetFromJSON(json) {
    return TableauNlpRefinementuiWidgetTableCalcWidgetFromJSONTyped(json, false);
}
exports.TableauNlpRefinementuiWidgetTableCalcWidgetFromJSON = TableauNlpRefinementuiWidgetTableCalcWidgetFromJSON;
function TableauNlpRefinementuiWidgetTableCalcWidgetFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'aggregationExpNlg': !runtime_1.exists(json, 'aggregation_exp_nlg') ? undefined : json['aggregation_exp_nlg'],
        'activeMeasureFieldGraphId': !runtime_1.exists(json, 'active_measure_field_graph_id') ? undefined : json['active_measure_field_graph_id'],
        'activeMeasureAggregationConceptId': !runtime_1.exists(json, 'active_measure_aggregation_concept_id') ? undefined : json['active_measure_aggregation_concept_id'],
        'measureFields': !runtime_1.exists(json, 'measure_fields') ? undefined : (json['measure_fields'].map(_1.TableauNlpSemanticmodelFieldFromJSON)),
        'measureFieldIndex': !runtime_1.exists(json, 'measure_field_index') ? undefined : json['measure_field_index'],
        'measureIndex': !runtime_1.exists(json, 'measure_index') ? undefined : json['measure_index'],
        'asPercentage': !runtime_1.exists(json, 'as_percentage') ? undefined : json['as_percentage'],
        'activeAddressingAggregationConceptId': !runtime_1.exists(json, 'active_addressing_aggregation_concept_id') ? undefined : json['active_addressing_aggregation_concept_id'],
        'availableAddressingAggregationConceptId': !runtime_1.exists(json, 'available_addressing_aggregation_concept_id') ? undefined : json['available_addressing_aggregation_concept_id'],
        'activeAddressingFieldGraphId': !runtime_1.exists(json, 'active_addressing_field_graph_id') ? undefined : json['active_addressing_field_graph_id'],
        'addressingFields': !runtime_1.exists(json, 'addressing_fields') ? undefined : (json['addressing_fields'].map(_1.TableauNlpSemanticmodelFieldFromJSON)),
        'activeAddressingGroupConceptId': !runtime_1.exists(json, 'active_addressing_group_concept_id') ? undefined : json['active_addressing_group_concept_id'],
        'availableAddressingGroupConceptId': !runtime_1.exists(json, 'available_addressing_group_concept_id') ? undefined : json['available_addressing_group_concept_id'],
        'activeAddressingGroup': !runtime_1.exists(json, 'active_addressing_group') ? undefined : _1.TableauNlpRefinementuiWidgetTableCalcWidgetGroupAndDisplayStringFromJSON(json['active_addressing_group']),
        'availableAddressingGroups': !runtime_1.exists(json, 'available_addressing_groups') ? undefined : (json['available_addressing_groups'].map(_1.TableauNlpRefinementuiWidgetTableCalcWidgetGroupAndDisplayStringFromJSON)),
        'nestedGroupAndDisplayString': !runtime_1.exists(json, 'nestedGroupAndDisplayString') ? undefined : json['nestedGroupAndDisplayString'],
    };
}
exports.TableauNlpRefinementuiWidgetTableCalcWidgetFromJSONTyped = TableauNlpRefinementuiWidgetTableCalcWidgetFromJSONTyped;
function TableauNlpRefinementuiWidgetTableCalcWidgetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'aggregation_exp_nlg': value.aggregationExpNlg,
        'active_measure_field_graph_id': value.activeMeasureFieldGraphId,
        'active_measure_aggregation_concept_id': value.activeMeasureAggregationConceptId,
        'measure_fields': value.measureFields === undefined ? undefined : (value.measureFields.map(_1.TableauNlpSemanticmodelFieldToJSON)),
        'measure_field_index': value.measureFieldIndex,
        'measure_index': value.measureIndex,
        'as_percentage': value.asPercentage,
        'active_addressing_aggregation_concept_id': value.activeAddressingAggregationConceptId,
        'available_addressing_aggregation_concept_id': value.availableAddressingAggregationConceptId,
        'active_addressing_field_graph_id': value.activeAddressingFieldGraphId,
        'addressing_fields': value.addressingFields === undefined ? undefined : (value.addressingFields.map(_1.TableauNlpSemanticmodelFieldToJSON)),
        'active_addressing_group_concept_id': value.activeAddressingGroupConceptId,
        'available_addressing_group_concept_id': value.availableAddressingGroupConceptId,
        'active_addressing_group': _1.TableauNlpRefinementuiWidgetTableCalcWidgetGroupAndDisplayStringToJSON(value.activeAddressingGroup),
        'available_addressing_groups': value.availableAddressingGroups === undefined ? undefined : (value.availableAddressingGroups.map(_1.TableauNlpRefinementuiWidgetTableCalcWidgetGroupAndDisplayStringToJSON)),
        'nestedGroupAndDisplayString': value.nestedGroupAndDisplayString,
    };
}
exports.TableauNlpRefinementuiWidgetTableCalcWidgetToJSON = TableauNlpRefinementuiWidgetTableCalcWidgetToJSON;
